//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import Boeking from './Boekingen/Boeking.vue';
export default {
  name: 'Boekingen',
  components: {
    Boeking,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function () {
    return {
      page: 1,
      max_num_pages: 1,
      selected_id: '',
      boekingen: [],
    };
  },
  methods: {
    setAccepted(id){
      this.$set(this.boekingen[this.boekingen.findIndex(b => b.id === parseInt(id))], 'is_definitive', 1);
    },
    handleSelect: function (id) {
      this.selected_id = id;
      let url = new URL(window.location);
      url.searchParams.set('id', id);
      history.pushState({}, null, url);
    },
    getBoekingen: function () {
      const self = this;
      axios.get(`${this.ajax}?action=boekingen&expert=${this.expert}&paged=${this.page}`).then(res => {
        const { boekingen, max_num_pages } = res.data;
        self.boekingen = boekingen;
        self.max_num_pages = max_num_pages;
      }).catch(error => {
        console.log(error);
      });
    },
    handlePagination: function (page) {
      if (page === 'next') {
        this.page++;
      } else if (page === 'prev') {
        this.page--;
      } else {
        this.page = page;
      }
      if (this.page < 1) {
        this.page = 1;
      }
      if (this.page > this.max_num_pages) {
        this.page = this.max_num_pages;
      }
      this.getBoekingen();
    },
  },
  mounted: function () {
    this.getBoekingen();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('id')) {
      this.selected_id = urlParams.get('id');
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Boekingen.vue